import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, of } from 'rxjs';

import { UtilService, SharedService} from '@services';
import { IMainMenu, MenuItem } from '@interfaces';
import { AuthService, BenefitManagementService } from '@core';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'sidebar',
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.scss'],
    standalone: false
})
export class SidebarComponent implements OnInit {
  @Output() sideBarToggleSubMenu: EventEmitter<boolean> = new EventEmitter<boolean>(window.innerWidth < 766 ? true : false);
  public accessRoles: IMainMenu[];
  public selectedMenu = 'Co-pay Schedule';
  public selectedMainMenu = 'Benefit Tools';
  public showSubMenus = true;
  isInternalUser$: Observable<boolean> = of(false);
  isSelected = false;
  constructor(
    public readonly router: Router,
    private readonly utilService: UtilService,
    private authService: AuthService,
    private benefitService: BenefitManagementService,
    private sharedService: SharedService
  ) { }

  ngOnInit(): void {
    let accessLevel;
    this.sharedService.accessLevel$.subscribe((v) => {
      accessLevel = v;
      this.accessRoles = this.utilService.getAccessRoles(accessLevel ? accessLevel : 'Level A');
    })
    this.isInternalUser$ = this.benefitService.isInternalUser();
    if (window.location.pathname.includes('audit-log')) {
      this.selectedMainMenu = 'Audit Logs';
    }
  }

  public clickMainMenu(menuItem: IMainMenu): void {
    if (menuItem.name) {
      this.selectedMainMenu = menuItem.name;
      if (this.selectedMainMenu === 'Benefit Tools') {
        this.showSubMenus = !this.showSubMenus;
        this.selectedMenu = 'Co-pay Schedule';
        this.router.navigateByUrl('/management/copay-schedule');
      }
      if (menuItem.route) {
        this.sideBarToggleSubMenu.emit(window.innerWidth < 766 ? true : false);
        this.router.navigateByUrl(menuItem.route);
      }
    }
  }

  // get isInternalUser(): boolean {
  //   if (this.authService.userEmail.split('@')[1] == 'empirxhealth.com') {
  //     return true;
  //   }
  //   return false;
  // }

  get redirectToTredium(): string {
    return environment.trediumUrl;
  }

  public clickMenu(menu: MenuItem): void {
    this.sideBarToggleSubMenu.emit(window.innerWidth < 766 ? true : false);
    this.selectedMainMenu = 'Benefit Tools';
    this.selectedMenu = menu.name;
    this.router.navigateByUrl(menu.route);
  }

  public goToHome() {
    this.router.navigateByUrl('/app');
  }
}
